export const expertListCn = {
    ssts:"专家名称",
    ytxshfl:"24小时回复率"
}


// WEBPACK FOOTER //
// ./src/lang/home/expertList/indexCn.js